module.exports = __webpack_public_path__ + "static/media/HomeFilled.ed87eece.svg";